<template>
  <v-layout  row wrap >
    <form autocomplete="off">

    <v-flex xs12 >
      <p>Excellent! Check your {{appName}}'s ID data below. </p>
    </v-flex>
      <v-flex xs12 pt-3>
        <v-layout text-xs-center align-center justify-center column>
          <div class="blue--text font-weight-bold" v-text="email" />
          <div class="font-weight-bold" v-text="phone" />
          <div v-text="addressLine1" />
          <div v-text="addressLine2" />
          <div v-text="city + ', ' + stateName" />
          <div v-text="'Postal Code: ' + postalCode + ', ' + countryName" />
        </v-layout>

      </v-flex>
      <!------------------- USER CERTIFICATE ------------------------------------->
      <UserCertificate
        :app-icon="appIcon"
        :app-name="appName"
        :app-name-class="appNameClass()"
        :default-name="defaultName"
        :f-name="fName"
        :l-name="lName"
        :image-data="imageData" />
      <!------------------- /USER CERTIFICATE ------------------------------------->
    <v-flex xs12 >
      <v-checkbox
        :error-messages="errors.collect('checkbox')"
        v-validate="'required'"
        data-vv-name="checkbox"
        v-model="checkbox">
        <template v-slot:label>
          <div>
            I attest to the ID data and accept the
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <a
                  target="_blank"
                  href="https://cogneti.com/home/terms"
                  @click.stop
                  v-on="on"
                >
                  License and terms of use
                </a>
              </template>
              Opens in new window
            </v-tooltip>
          </div>
        </template>
      </v-checkbox>
    </v-flex>
      <v-flex xs12 >
        <v-btn block class="mr-0"
               :loading="loading"
               @click="register()" color="success">CREATE ACCOUNT</v-btn>
        <v-btn block class="ml-0" @click="goToSignupStep(page, 'get-location-info')" color="primary">&#8592; Back</v-btn>
      </v-flex>
    </form>



    <v-dialog
      v-model="creationLoaderDialog"
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          Please wait. Your account is being created...
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

  </v-layout>

</template>

<script>
  import crypto from '@/mixins/crypto'
  import Vue from 'vue'
  import VeeValidate from 'vee-validate'
  import {mapGetters, mapMutations} from 'vuex'
  import common from '@/mixins/common'
  import UserCertificate from './UserCertificate'

  Vue.use(VeeValidate)

  function getOS () {
    let userAgent = window.navigator.userAgent
    let platform = window.navigator.platform
    let macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K']
    let windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE']
    let iosPlatforms = ['iPhone', 'iPad', 'iPod']
    let os = 'Desktop'
    // Initially following code return Different OS but for now it will return only iOS, Android and Desktop
    if (macosPlatforms.indexOf(platform) !== -1) {
      os = 'DESKTOP'
    } else if (iosPlatforms.indexOf(platform) !== -1) {
      os = 'IOS'
    } else if (windowsPlatforms.indexOf(platform) !== -1) {
      os = 'DESKTOP'
    } else if (/Android/.test(userAgent)) {
      os = 'ANDROID'
    } else if (!os && /Linux/.test(platform)) {
      os = 'DESKTOP'
    }
    return os
  }
  export default {
    name: 'UpdateProfile',
    components: {UserCertificate},
    props: {
      page: {
        default: 'SignUp',
        type: String
      }
    },
    data () {
      return {
        appIcon: require('@/assets/logos/' + process.env.APP_ICON),
        appName: process.env.APP_NAME,
        defaultName: 'Your Name',
        loc: null,
        checkbox: null,
        isLocationOn: false,
        isFormValidated: false,
        loading: false,
        uname: '',
        e1: true,
        creationLoaderDialog: false,
        password: '',
        dictionary: {
          attributes: {
            email: 'E-mail Address'
          },
          custom: {
            checkbox: {
              required: 'Please select license and terms of use'
            }
          }
        }
      }
    },
    computed: {
      ...mapGetters('registration', ['getUserDetails']),
      addressLine1 () {
        return this.getUserDetails.address_line1
      },
      addressLine2 () {
        return this.getUserDetails.address_line2
      },
      postalCode () {
        return this.getUserDetails.postal_code
      },
      fName () {
        return this.getUserDetails.first_name
      },
      imageData () {
        return this.getUserDetails.profile_image
      },
      lName () {
        return this.getUserDetails.last_name
      },
      email () {
        return this.decryptData(this.getUserDetails.email)
      },
      phone () {
        return '+' + this.decryptData(this.getUserDetails.phone)
      },
      selectedCountry () {
        return (this.getUserDetails.country)
      },
      selectedState () {
        return (this.getUserDetails.state)
      },
      city () {
        return (this.getUserDetails.city)
      },
      countryName () {
        return this.getUserDetails.country_name
      },
      stateName () {
        return this.getUserDetails.state_name
      }
    },
    mounted () {
      this.$validator.localize('en', this.dictionary)
    },
    methods: {
      ...mapMutations('registration', [
        'setUser', 'resetUser'
      ]),
      appNameClass () {
        return this.appName.length > 25 ? 'body-2' : 'subheading'
      },
      register () {
        if (!this.$auth.token()) {
          return false
        }
        this.$validator.validateAll().then((result) => {
          if (result) {
            this.creationLoaderDialog = true
            this.$store.commit('setLoadingDialog', true, { root: true })

            const data = {
              'email': this.email,
              'emailOtpId': null,
              'password': null,
              'firstName': this.fName,
              'lastName': this.lName,
              'profile': {
                'city': this.city,
                'phoneNumber': this.phone,
                'phoneOtpId': this.getUserDetails.phone_otp_id,
                'addressLine1': this.addressLine1,
                'addressLine2': this.addressLine2,
                'stateId': this.selectedState,
                'countryId': this.selectedCountry,
                'postalCode': this.postalCode,
                'device': getOS()
              }
            }
            this.$http({
              url: process.env.API_URL + '/ws/userservice/course/rch/register',
              method: 'POST',
              data
            }).then((res) => {
              this.creationLoaderDialog = false
              this.$store.commit('setLoadingDialog', false, { root: true })

              this.setUser({
                ...this.getUserDetails,
                welcome: true,
                existing_user: true
              })

              this.$router.push({name: 'Programs'})
            }, error => {
              this.creationLoaderDialog = false
              this.$store.commit('setLoadingDialog', false, { root: true })
              this.$store.commit('flashError', error.message, { root: true })
              this.creationLoaderDialog = false
            }).catch(error => {
              this.creationLoaderDialog = false
              this.$store.commit('setLoadingDialog', false, { root: true })
              this.$store.commit('flashError', error.message, { root: true })
            })
          } else {
            this.creationLoaderDialog = false
          }
        })
      },
      jsonToQueryString (json) {
        return '' +
          Object.keys(json).map(function (key) {
            return encodeURIComponent(key) + '=' +
              encodeURIComponent(json[key])
          }).join('&')
      }
    },
    mixins: [crypto, common]
  }
</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/views/sign-up/UpdateProfile.vue